// extracted by mini-css-extract-plugin
export default {"scoreWrapper":"Score_scoreWrapper__nwjmK","subScore":"Score_subScore__b35bo"};